import {BasicScenario} from '../../framework/parameters/BasicScenario';

export class DomainScenario extends BasicScenario {
manageOwner: boolean | null;
manageUsers: boolean | null;
}

